export const calculateReadingTime = (text: string, wordsPerMinute: number = 200): string => {
  const cleanText = text.replace(/<\/?[^>]+(>|$)/g, '');
  const wordCount = cleanText.trim().split(/\s+/).length;
  const minutes = Math.max(1, Math.ceil(wordCount / wordsPerMinute));
  let readingTime = `${minutes} min`;

  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const hoursMinutes = minutes % 60;
    readingTime = `${hours} h ${hoursMinutes} min`;
  }

  return readingTime;
};
